import { createAction } from 'typesafe-actions';
import { NotificationOptions } from 'components/elements';

export enum NotificationAction {
  Error = 'NOTIFICATION_ERROR',
  Information = 'NOTIFICATION_INFO',
  Success = 'NOTIFICATION_SUCCESS',
  Warning = 'NOTIFICATION_WARNING',
}

type NotificationActionOptions = Omit<NotificationOptions, 'severity'>;

export const notificationError = createAction(
  NotificationAction.Error,
)<NotificationActionOptions>();
export const notificationInfo = createAction(
  NotificationAction.Information,
)<NotificationActionOptions>();
export const notificationSuccess = createAction(
  NotificationAction.Success,
)<NotificationActionOptions>();
export const notificationWarning = createAction(
  NotificationAction.Warning,
)<NotificationActionOptions>();
